import i18n from 'modules/core/lib/i18n'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const ModulesPromotionsPage = () => {
  if (true) {
    ;[
      i18n.t('marketplace.black_friday_promo.marketplace_list.tab'),
      i18n.t('marketplace.black_friday_promo.marketplace_list.title_tag'),
      i18n.t('marketplace.black_friday_promo.marketplace_list.title'),
      i18n.t('marketplace.black_friday_promo.marketplace_list.description'),
      i18n.t('marketplace.black_friday_promo.marketplace_list.description_2'),
      i18n.t('marketplace.black_friday_promo.marketplace_list.description_3'),
    ]
  }

  return <ResponsivePage.Body>Black Friday</ResponsivePage.Body>
}

export default ModulesPromotionsPage
